module.exports = __webpack_public_path__ + "static/media/balancer.b873063a.png";